import React, { useEffect, useState } from 'react';
import { FlatList, View } from 'react-native';
import { Icon } from 'react-native-elements';
import { useDispatch, useSelector } from 'react-redux';
import OrderCard from '../../../Componentsv1/OrderCard';
import Colors from '../../../constants/Colorsv2';
import { TouchableOpacity } from '../../../globalComponents/NativeOverrides';
import { navigate } from '../../../navigation/RootNavigation';
import { market_bulkGetOrders } from '../../../store/actionsv1/markets';
import { OrderProps } from '../../../store/types/mk_svc';


type OrderHolderProps = {
    order_ids: string[],
    width:number,
    view_mode:string,
    onRemoveOrder?: (order_id:string) => void
}
const OrderHolder = ({ order_ids, width, view_mode, onRemoveOrder }:OrderHolderProps) => {
    const dispatch = useDispatch();
    const orders:OrderProps[] = useSelector((state:any) => state.social.viewing_orders.filter((o:OrderProps) => order_ids.includes(o.order_id)), (left, right) => left[0]?.order_id == right[0]?.order_id)
    useEffect(() => {
        if(order_ids.length === 0){ return }
        //getOrdersFromServer()
        if(orders.length == 0){ dispatch(market_bulkGetOrders(order_ids)) }
    },[order_ids.length])

    const handleRemoveOrder = (order_id:string) => {
        if(!onRemoveOrder){ return }
        onRemoveOrder(order_id)
    }

    const renderOrders = (data:{item:OrderProps, index:number}) => {
        return (
            <View style={{ padding:10, width }}>
                <View>
                    <OrderCard view_mode='view' order={data.item}/>
                    {view_mode === 'view' ?
                    <TouchableOpacity style={{ position:'absolute', top:20, right:15, padding:5, borderRadius:100, justifyContent:'center', alignItems:'center', backgroundColor:Colors.brand.midnight }}
                    onPress={() => navigate('EventStack', { screen: 'Market', initial:false, params: { event_id:data.item.event_id, event_type: data.item.event_type, market_id:data.item.market_id } })}>
                        <Icon name='navigation' type='feather' size={12} color={Colors.shades.white} />
                    </TouchableOpacity>
                    :<></>}
                </View>
                {view_mode === 'edit' ?
                <TouchableOpacity style={{ position:'absolute', justifyContent:'center', alignItems:'center', borderRadius:100, top:10, right:10, width:20, height:20, backgroundColor:Colors.shades.white }} onPress={() => handleRemoveOrder(data.item.order_id)}>
                    <Icon name='x' type='feather' color={Colors.brand.slate} size={16}/>
                </TouchableOpacity>
                :<></>}
               
            </View>
        )
    }
    if(width === 0){ return <></> }
    return (
        <View style={{ flexDirection:'row', overflow: 'scroll' }}>
            {orders.map((o,i) => {
                return renderOrders({ item: o, index:i })
            })}
        </View>
    )
}

const areEqual = (prevProps:OrderHolderProps, nextProps:OrderHolderProps) => {
    if(prevProps.order_ids[0] !== nextProps.order_ids[0]){ return false }
    if(prevProps.width !== nextProps.width){ return false }
    return true
}

export default React.memo(OrderHolder, areEqual)